<template>
  <span id="post-invoices-section" v-if="$can(this.permissions.BILLING.POST_INVOICE)">
    <el-dropdown-item id="post-invoices-dropdown-item"  type="success" plain @click.native="dialogVisible = true" size="mini">
      <span class="more-actions-option">{{ $t('invoices.postInvoices') }}</span>
    </el-dropdown-item>
    <el-dropdown-item id="post-invoices-dropdown-item"  type="success" plain @click.native="handleOpenPdfOnly" size="mini">
      <span class="more-actions-option">{{ $t('invoices.postInvoicesPdfOnly') }}</span>
    </el-dropdown-item>
    <el-dialog
      :close-on-click-modal="false"
      v-on:open="handleOpen"
      v-on:close="handleClose"
      :title="onlyPdf ? $t('invoices.postInvoicesPdfOnly') : $t('invoices.postInvoices')"
      :visible.sync="dialogVisible"
      width="30%"
      class="dialog-with-cols"
      id="post-invoices-dialog"
      append-to-body
    >
      <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
        <el-row>
        <el-row>
        </el-row>
          <el-col :span="24" class="form-vertical-item">
            <el-form-item :label="$t('invoices.dateFrom')" prop="invoiceDateFrom"
                          class="inline-input">
              <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                v-model="form.invoiceDateFrom"
                format="MM/dd/yyyy"
                :clearable="false"
                type="date"
                @change="handleDateFromChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="24" :sm="24" :xs="24" class="form-vertical-item">
            <el-form-item :label="$t('invoices.dateTo')" prop="invoiceDateTo"
                          class="inline-input">
              <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                v-model="form.invoiceDateTo"
                format="MM/dd/yyyy"
                :clearable="false"
                type="date"
                @change="handleDateToChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- Only for "Post PDF Only": the posting path already skips what is filed, so the choice
             would mean nothing there. -->
        <el-row v-if="onlyPdf">
          <el-col :md="24" :sm="24" :xs="24" class="form-vertical-item">
            <el-form-item class="inline-input">
              <el-checkbox id="skip-already-filed-checkbox" v-model="form.skipAlreadyFiled">
                {{ $t('invoices.skipAlreadyFiled') }}
              </el-checkbox>
              <div><small class="hint">{{ $t('invoices.skipAlreadyFiledHint') }}</small></div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
        <el-button type="primary" id="form-post-invoices-button" @click="submitForm()" size="mini">{{ $t('invoices.postInvoices') }}</el-button>
        <el-button id="form-cancel-post-button" @click="dialogVisible = false" size="mini">{{ $t('invoices.cancelPostInvoice') }}</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import moment from 'moment';
import { Message } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  name: 'PostInvoicesDialog',
  computed: {
    ...mapGetters(['invoices']),
  },
  data() {
    return {
      dialogVisible: false,
      onlyPdf: false,
      form: {
        invoiceDateFrom: null,
        invoiceDateTo: null,
        uploadPdfOnly: false,
        skipAlreadyFiled: true
      },
      formRules: {
        invoiceDateFrom: [
          { required: true, message: this.$t('customerService.shipment.error.dateFromRequired'), trigger: 'blur' },
        ],
        invoiceDateTo: [
          { required: true, message: this.$t('customerService.shipment.error.dateToRequired'), trigger: 'blur' },
        ]
      }
    };
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        this.assign();
      });
    },
    handleOpenPdfOnly() {
      this.dialogVisible = true;
      this.onlyPdf = true;
    },
    handleClose() {
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.onlyPdf = false;
      });
    },
    handleDateFromChange() {
      if (moment(this.form.invoiceDateFrom).isAfter(moment(this.form.invoiceDateTo))) {
        this.form.invoiceDateTo = this.form.invoiceDateFrom;
      }
    },
    handleDateToChange() {
      if (moment(this.form.invoiceDateTo).isBefore(moment(this.form.invoiceDateFrom))) {
        this.form.invoiceDateFrom = this.form.invoiceDateTo;
      }
    },
    async submitForm() {
      const validForm = await this.$refs.form.validate().catch(() => {});
      if (!validForm) {
        return;
      }
      Message.closeAll();
      // Says what is happening instead of showing a mute spinner. Posting sends every invoice of the
      // range to Sage inside the request - around half a minute for a couple of hundred - and until
      // now nothing on screen suggested anything was going on.
      //
      // The overlay keeps locking the screen on purpose: the exclusive lock on the backend is only
      // claimed once posting is done, so this lock is what stops a second Post Invoices from starting
      // on top of the first. A non-blocking banner here would open that window.
      const loading = this.$loading({
        ...constants.LOADING.DEFAULT_CONFIG,
        text: this.form.uploadPdfOnly
          ? this.$t('invoices.backgroundProcess.startingPdfRun')
          : this.$t('invoices.backgroundProcess.postingToSage')
      });

      this.$store.dispatch('invoices/posting', this.form).then((response) => {
        this.$store.dispatch('invoices/search', {});
        loading.close();
        this.$message.success(response.message);
        this.dialogVisible = false;
        this.onlyPdf = false;
      }).catch(() => {
        loading.close();
      });
    },
    assign() {
      this.form.invoiceDateFrom = this.invoices.actualFilters.dateFrom || moment().subtract(1, 'days').toDate();
      this.form.invoiceDateTo = this.invoices.actualFilters.dateTo || this.invoices.actualFilters.dateFrom || moment().subtract(1, 'days').toDate();
      this.form.uploadPdfOnly = this.onlyPdf;
      this.form.skipAlreadyFiled = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.hint {
  color: #909399;
  font-size: 11px;
  line-height: 1.4;
  display: block;
  margin-top: -6px;
}
</style>
